import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'

export type ActiveOrg = {
    type: 'school' | 'childcareCentre'
    id: string
}

interface IOrgSlice {
    activeOrg: ActiveOrg | undefined
}

export const initialState: IOrgSlice = {
    activeOrg: undefined,
}

export const orgSlice = createSlice({
    name: 'org',
    initialState,
    reducers: {
        setOrgDefault: () => initialState,
        setOrg: (state, action: PayloadAction<ActiveOrg | undefined>) => {
            state.activeOrg = action.payload
        },
    },
})

export const selectOrg = (state: RootState) => state.org.activeOrg
export const selectActiveOrgId = (state: RootState) => state.org.activeOrg?.id

export const { setOrgDefault, setOrg } = orgSlice.actions

export default orgSlice.reducer
